export default __webpack_public_path__ + "static/media/addPlayListPlusIcon.16fbbef7.svg";